import { handlePDFClick } from "../../../utilities/handleFunctions/HandlePDFOpen"
import { allStatusListItems } from '../../../data/CategoriesData';
import { RiyalImgBLK } from '../../../components/common/RiyalImg';
import { editOrderOffer } from '../../../hooks/apiAxios';
import SuccessErrorMsg from "../../../utilities/SuccessErrorMsg"

export default function SuperAdminOfferDetails({ offerStatus, offerPrice, offerNote, offerFile, toast, orderId, loading, setLoading, setValue, handleSubmit, ToastContainer }) {

    async function onOfferChange(formData) {
        setLoading(true);
        console.log(formData);

        try {
            const response = await editOrderOffer(orderId, formData);

            if (response.data.isSuccess) {
                toast.success("تم حفظ العرض .. ")
                setTimeout(() => {
                    window.location.reload();
                }, 3000);

            } else {
                toast.error("حدث خطأ ما، حاول مرة أخرى");
            }
        } catch (error) {
            console.error("Error during form submission: ", error);
            toast.warn("حدث خطأ ما، تواصل مع الدعم");
        } finally {
            setLoading(false);
        }
    }

    return (
        <form className='d-flex flex-wrap text-start'
            onSubmit={handleSubmit(onOfferChange)}>
            <table className="table">
                <tbody>
                    <tr>
                        <td>السعر المرسل</td>
                        <td>{offerPrice}<RiyalImgBLK /></td>
                    </tr>
                    <tr>
                        <td>العرض</td>
                        <td>
                            <button className="btn-masar-sm btn-med-gray m-1" onClick={handlePDFClick} value={offerFile}>PDF</button>
                        </td>
                    </tr>
                    <tr>
                        <td>الملاحظات</td>
                        <td>{offerNote}</td>
                    </tr>
                    <tr>
                        <td>حالة الطلب</td>
                        <td>
                            <select className='form-select form-select-sm'
                                onChange={e => setValue("status", e.target.value)}
                            >
                                <option defaultValue={offerStatus}>{offerStatus}</option>
                                {allStatusListItems
                                    .filter(oneStatus => oneStatus.en !== offerStatus)
                                    .map((oneStatus, index) => (
                                        <option key={index} value={oneStatus.en}>
                                            {oneStatus.ar}
                                        </option>
                                    ))}
                            </select>

                        </td>
                    </tr>
                </tbody>
            </table>

            <button className="btn-masar btn-dark-orange ms-auto" type="submit">
                {loading &&
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"></span>
                }
                حفظ</button>
            <SuccessErrorMsg
                ToastContainer={ToastContainer}
            />
        </form>
    )
}